<template>
    <produtos></produtos>
</template>

<script>
import Produtos from '../Produtos.vue'

export default {                                                                                                     
    components: {
        'produtos': Produtos
    }    
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/PaginaProdutos.vue